



















































































































































































































import { Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import CreateCampaignDialogFlowLanding from './create-campaign-dialog-flow-landing.vue';
import CreateCampaignDialogFlowOffer from './create-campaign-dialog-flow-offer.vue'
import FlowPathMixin from '@/views/reports/mixins/flow/flow-path-mixin';
import CreateCampaignDialogFlowPathErrorsMixin from '@/views/reports/mixins/flow/create-campaign-dialog-flow-path-errors-mixin';
import {AclMixin} from '@/components/acl/acl-mixin';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';

@Component({
  components: {
    CreateCampaignDialogFlowLanding,
    CreateCampaignDialogFlowOffer
  }
})
export default class CreateCampaignDialogFlowPath extends mixins<FlowPathMixin, CreateCampaignDialogFlowPathErrorsMixin,AclMixin,PlanLimitsMixin>(FlowPathMixin, CreateCampaignDialogFlowPathErrorsMixin,AclMixin,PlanLimitsMixin) {
  @Prop()
  path: any;

  @Prop({ default: false })
  isDisabledWeight: boolean;

  @Prop()
  paths: any;

  @Prop()
  form: any;

  @Prop()
  setLandingOptions: any;

  @Prop()
  setOfferOptions: any;

  @Prop()
  countryId: string;

  @Prop({ default: () => [] as string[] })
  errorConditionPrefix: string[];

  @Prop() 
  dialogRepositionParam: string;
  
  @Prop()
  offerOptions: Offer[];

  @Prop()
  landingOptions: Landing[];

  addOfferEvent: string = 'campaign-new-offer';
  editOfferEvent: string = 'campaign-edit-offer';
  deleteOfferEvent: string = 'campaign-delete-offer';
  addLandingEvent: string = 'campaign-new-landing';
  editLandingEvent: string = 'campaign-edit-landing';
  deleteLandingEvent: string = 'campaign-delete-landing';
  
  landingDisabledInStateActive = ['fixOnLanding','fixOnOffers','landings','landingsAndOffers']

  get isDirectLinking() {
    return this.path.directLinking
  }

  get activeSwitchDisabled() {
    return this.path.weight <= 0 || isNaN(this.path.weight);
  }

  get active() {
    return !this.activeSwitchDisabled ? this.path.status : 'inactive';
  }

  get $FFReportingFlowRulePathEnabled() {
    return this.$FF?.reportingFlowRulePath?.enabled;
  }

  set active(value: string) {
    this.path.status = value;
  }

  get errorCondition(): any[] {
    return [
      ...this.errorConditionPrefix,
      ...this.getPathErrorCondition(this.ruleIndex, this.pathIndex)
    ];
  }
  
  deletePath() {
    this.bus.emit('campaign-delete-path', this.ruleIndex, this.pathIndex);
  }

  @Watch('form.rotation')
  onFormRotationChanged(value: string) {
    if(this.landingDisabledInStateActive.includes(value)){
      this.path.directLinking = false;
    }
  }

  translatedName(name:string) {
    return name.replace('Path',this.t('Path'));
  }

  get offersCount() {
    return this.path.landings?.[0]?.offers || 0;
  }
}
